module.exports = __webpack_public_path__ + "img/delivery.c540b667.webp";